import { useLocation, matchPath } from 'react-router-dom';

const CONTENT_LIST_ROUTES = ['/', '/:categorySlug'];

export const useCurrentRoute = () => {
  const location = useLocation();

  let isAllContentList = CONTENT_LIST_ROUTES.some((path) =>
    matchPath({ path, end: true }, location.pathname)
  );

  if (location.pathname === '/about-fund') {
    return { isAllContentList: false };
  }

  return { isAllContentList };
};
